// js
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import { makeGetIsActiveArea } from '../../selectors/dsa/areaSelectors';
// css
import '../../styles/components/common/AreaCard.scss';


function AreaCard({area, isActiveArea, children}) {

  return (
    <div className={`area-card text-center ${isActiveArea ? 'active-card' : 'inactive-card'}`}>
      <Link to={`${browserHistory.getCurrentLocation().pathname}/${area.id}`}
        className={`area-card__title ${isActiveArea ? '' : 'disabled'}`}>{area.title}</Link>
      {children}
    </div>
  );
}

const mapStateToProps = (state, props) => {
  const getIsActiveArea = makeGetIsActiveArea();

  return {
    isActiveArea: getIsActiveArea(state, props)
  };
};

AreaCard.propTypes = {
  area: PropTypes.object.isRequired,
  isActiveArea: PropTypes.bool,
  children: PropTypes.array
};

export default connect(mapStateToProps)(AreaCard);



// WEBPACK FOOTER //
// ./src/components/common/AreaCard.js